<!-- AutoSyncroTimeSelect.vue -->
<template>
  <v-form ref="refForm">
    <div class="d-flex flex-wrap mb-2 max-width-400">
      <div class="flex_center px-2 pt-5 pb-3">
        <div class="select_item">
          <v-select
            class="select_hour"
            v-model="post_hour"
            :items="selectITem.hourItem"
            item-text="text"
            item-value="value"
            label="時"
            dense
            hide-details="false"
            :rules="[timerCheck(post_hour, 'post_hour'), timerRolus]"
          />
        </div>
        <div class="select_item ml-3">
          <v-select
            class="select_minute"
            v-model="post_minute"
            :items="selectITem.minuteItem"
            item-text="text"
            item-value="value"
            label="分"
            dense
            hide-details="false"
            :rules="[timerCheck(post_minute, 'post_minute'), timerRolus]"
          />
        </div>
        <div class="select_item ml-3">
          <general-button btn_color="gray" btn_block @click-event="clearTime">
            <template v-slot:icon>
              <v-icon left>mdi-alarm</v-icon>
            </template>
            クリア
          </general-button>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
import { ref, reactive, toRefs, onMounted } from "@vue/composition-api";
import selectITem from "@/common/selectItem.js";

export default {
  props: ["p_hour", "p_minute"],
  setup(props, ctx) {
    const refForm = ref();
    const state = reactive({
      timerRolus: true,
      post_hour: null,
      post_minute: null,
    });

    onMounted(() => {
      state.post_hour = props.p_hour;
      state.post_minute = props.p_minute;
    });

    // 時刻設定のクリア
    const clearTime = () => {
      state.post_hour = null;
      state.post_minute = null;
    };

    // 入力された値のチェック
    const timerCheck = (input_data, itemName) => {
      if (itemName == "post_hour") {
        if (state.post_minute != null && input_data != null) {
          state.timerRolus = true;
          return true;
        }
        if (state.post_minute == null && input_data == null) {
          state.timerRolus = true;
          return true;
        }
      }
      if (itemName == "post_minute") {
        if (state.post_hour != null && input_data != null) {
          state.timerRolus = true;
          return true;
        }
        if (state.post_hour == null && input_data == null) {
          state.timerRolus = true;
          return true;
        }
      }
      state.timerRolus = false;
      return false;
    };

    const getTime = () => {
      return { hour: state.post_hour, minute: state.post_minute };
    };

    const checkForm = () => {
      return refForm.value.validate();
    };

    return {
      selectITem,
      clearTime,
      timerCheck,
      ...toRefs(state),
      refForm,
      getTime,
      checkForm,
    };
  },
};
</script>

<style scoped>
.flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.max-width-400 {
  max-width: 400px;
}
</style>
